/**
 * Image Component
 *
 * A themed wrapper around Mantine's Image component.
 * Renders an image with fallback support and responsive sizing.
 */

import { Image as MantineImage, ImageProps } from '@mantine/core';
import { forwardRef } from 'react';

export interface ThemedImageProps extends ImageProps {}

const Image = forwardRef<HTMLImageElement, ThemedImageProps>((props, ref) => (
  <MantineImage ref={ref} {...props} />
));

Image.displayName = 'Image';

export default Image;
